// extracted by mini-css-extract-plugin
module.exports = {"Bronte_formWrapper":"style_Bronte_formWrapper__AQ7py","Arcade_formWrapper":"style_Arcade_formWrapper__BCQLb"};